import { DocumentationItem } from '../redux/common/definitions';

export const documentationFilter = (
  documentArray: DocumentationItem[],
  [...documentation_id]: string[],
): DocumentationItem[] => {
  return documentArray.filter(element => documentation_id.includes(element.code));
};
